import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Http } from '@angular/http';

// users
import { User } from '../entities/users';

// tools
import { Tools } from '../utilities/tools';

@Injectable()
export class AuthService {
    private authKey: string = environment.userKey;
    private endPoint: string = environment.server;

    userDataChanged: EventEmitter<User> = new EventEmitter();

    constructor(
        private http: Http,
        private router: Router) {
    }

    changeLang(lang: string): Observable<number> {
        const headers: any = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
        const options: any = new RequestOptions({ headers: headers });
        return this.http
            .put(this.endPoint + 'api/app/users/language/' + lang, null, options)
            .map(response => response.status);
    }

    signIn(user: string, pwd: string): Observable<User> {
        const headers: any = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
        const options: any = new RequestOptions({ headers: headers });
        return this.http
            .post(this.endPoint + 'api/auth/login', { Email: user, Pwd: pwd }, options)
            .map(response => Tools.Deserialize(response.text()) as User);
    }

    signOut(): void {
        this.http
            .get(this.endPoint + 'api/auth/logout', { withCredentials: true }).subscribe(
                null,
                null,
                () => {
                    this.clear();
                }
            );
    }

    store(user: User): void {
        this.userDataChanged.emit(user);
        localStorage.setItem(this.authKey, JSON.stringify(user));
    }

    clear(): void {
        localStorage.removeItem(this.authKey);
    }

    load(): User {
        const user: User = Tools.Deserialize(localStorage.getItem(this.authKey));
        return user;
    }

    isAuthenticated(): boolean {
        const user: User = this.load();
        if (user !== null) {
            return true;
        }
        return false;
    }
}




// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/shared/services/auth.service.ts